import React from 'react'

interface Props {
    condition: unknown
    children:
        | ((condition: boolean) => React.ReactElement | React.ReactElement[])
        | React.ReactElement
        | React.ReactElement[]
}

const ConditionalRenderer = ({ children, condition }: Props) => {
    return <>{typeof children === 'function' ? children(Boolean(condition)) : Boolean(condition) && children}</>
}

export default ConditionalRenderer
